const caseStatus = Object.freeze({
  FlujoEnProceso: -1, //No es parte de los estatus en si, es utilizado para filtrar los casos que esten en proceso (Worklow.WorkflowStepId = 2)
  Atendido: 10038,
  EnProceso: 2,
  Resuelto: 3,
  Cancelado: 4,
  ReferidoDocencia: 5,
  Nuevo: 6,
  ReferidoProgramacion: 22,
  ReferidoConsulta: 23,
  PendientePublicacion: 24,
  EnProcesoProgramacion: 25,
  ResueltoProgramacion: 26,
  PendienteInformacion: 27,
  DevueltoProgramacion: 28,
  DevueltoAsistenciaMIPE: 29,
  EnProcesoAnalisis: 30,
  EnProcesoOrientacion: 31,
  EnEspera: 10037,
});

export const CaseStatusDescription = Object.freeze({
  [caseStatus.FlujoEnProceso]: 'En Proceso',
  [caseStatus.EnProceso]: 'En Proceso',
  [caseStatus.Resuelto]: 'Resuelto',
  [caseStatus.Cancelado]: 'Cancelado',
  [caseStatus.ReferidoDocencia]: 'Referido a Docencia',
  [caseStatus.Nuevo]: 'Nuevo',
  [caseStatus.ReferidoProgramacion]: 'Referido a Programación',
  [caseStatus.ReferidoConsulta]: 'Referido a Consulta',
  [caseStatus.PendientePublicacion]: 'Pendiente Publicación',
  [caseStatus.EnProcesoProgramacion]: 'En Proceso Programación',
  [caseStatus.ResueltoProgramacion]: 'Resuelto Programación',
  [caseStatus.PendienteInformacion]: 'Pendiente de Información',
  [caseStatus.DevueltoProgramacion]: 'Devuelto a Programación',
  [caseStatus.DevueltoAsistenciaMIPE]: 'Devuelto a Asistencia MiPE',
  [caseStatus.EnProcesoAnalisis]: 'En Proceso de Análisis',
  [caseStatus.EnProcesoOrientacion]: 'En Proceso de Orientación',
});

export default caseStatus;
